import React, { useState, useRef, useCallback, useEffect, forwardRef } from 'react'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Icon from '../../../@core/components/icon'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { Button } from '@mui/material'
import { showSnackbar } from '../toast/snackbarService'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import { useUploadFiles } from '../../../hooks/uploadFiles'
import { userData } from '../../../hooks/userData'
import CustomAutocomplete from '../../../@core/components/mui/autocomplete'
import format from 'date-fns/format'
import CustomTextField from '../../../@core/components/mui/text-field'

const Upload = (props) => {
  // ** Props

  const theme = useTheme()
  const uploadFile = useUploadFiles()
  const gst_claim = userData()

  const [files, setFiles] = useState([])
  const [errorFiles, setErrorFiles] = useState({})
  const [isFileUploading, setIsFileUploading] = useState(false)
  const [userList, setUserList] = useState([])
  const fileInputRefs = useRef({})
  const [uploadedFiles, setUploadedFiles] = useState({})
  const [selectedAccount, setSelectedAccount] = useState(null);

  useEffect(() => {
    let platformList = gst_claim.user.map((e) => ({
      email: e.companyName,
      accountNumber: e.platformSupplierId,
      id: e.id
    }));
    setUserList(platformList)
  }, [gst_claim])

  useEffect(() => {
    setUploadedFiles({})
  }, [selectedAccount])


  const fileBoxes = [
    { id: "orders", label: "Order", icon: "ph:file-xls" },
    { id: "returns", label: "Return", icon: "ph:file-xls" },
    { id: "intransit", label: "Intransit", icon: "ph:file-xls" },
    { id: "payments", label: "Payments", icon: "ph:file-xls" },
    { id: "claims", label: "Spf Claims", icon: "ph:file-xls" },
  ]

  const handleBoxClick = (id) => {
    if (fileInputRefs.current[id]) {
      fileInputRefs.current[id].click()
    }
  }

  const handleFileChange = (event, id) => {
    const selectedFiles = event.target.files
    if (!selectedFiles.length) return
    const errorFile = []
    const newFiles = []
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i]

      // Validation for each file based on the box id
      const isValidFile = validateFile(file, id)
      if (isValidFile === true) {
        newFiles.push(file)
      } else {
        errorFile.push({ [id]: `${isValidFile} File Name Not Matched` })

        showSnackbar(`File Name Not Matched`, "error")
      }
    }

    if (newFiles.length > 0) {
      // Update uploaded files for this box
      setUploadedFiles((prevFiles) => ({
        ...prevFiles,
        [id]: [...(prevFiles[id] || []), ...newFiles],
      }))
    }

    if (errorFile.length > 0) {
      setErrorFiles(prevState => ({
        ...prevState,
        [id]: [...(prevState[id] || []), ...errorFile],
      }));
    }
  }

  const renderError = useCallback(() => {
    return (Object.entries(errorFiles).length ?
      <Box style={{ width: '100%' }}>
        <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
          <TableHead>
            <TableRow>
              <TableCell>type</TableCell>
              <TableCell>File Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(errorFiles).map(([type, errors]) => (
              errors.map((error, index) => (
                <TableRow key={index}>
                  <TableCell>{type}</TableCell>
                  <TableCell>{Object.values(error)[0]}</TableCell>
                </TableRow>
              ))
            ))}
          </TableBody>
        </Table>
      </Box >
      :
      ""
    )
  }, [errorFiles])

  // Validate file names based on the box id
  const validateFile = (file, id) => {
    const filename = file.name
    switch (id) {
      case 'payments': {
        const result = filename.split("_").slice(1, 6).join("_")
        if (result === 'SP_ORDER_ADS_REFERRAL_PAYMENT') {
          return true
        } else {
          return filename
        }
      }
      case 'orders': {
        if (filename.startsWith('Orders')) {
          return true
        } else {
          return filename
        }
      }
      case 'returns': {
        if (filename.startsWith('completed_delivered')) {
          return true
        } else {
          return filename
        }
      }
      case 'intransit': {
        if (filename.startsWith('intransit')) {
          return true
        } else {
          return filename
        }
      }
      case 'claims': {
        const match = filename.match(/Supplier-\d+_(.*?)\-from/)

        if (match && match[1] === 'Status-all_Created') {
          return true
        } else {
          return filename
        }
      }
      default:
        return false
    }
  }

  const resetUploadedFileData = async () => {
    setUploadedFiles({})
    setErrorFiles({})
  }

  const submitFiles = async () => {
    console.log('uploadedFiles', uploadedFiles)
    // if (uploadedFiles) {
    //   setIsFileUploading(true)
    //   // uploadFile.postUploadFiles(uploadedFiles, (response) => {
    //   //   if (response.status === "success") {
    //   //     showSnackbar("Record Upload successfully!", "success");
    //   //   } else {
    //   //     showSnackbar("Something Went Wrong", "error");
    //   //   }
    //   // })
    //   setIsFileUploading(false)
    // } else {
    //   setIsFileUploading(false)
    //   showSnackbar(`Select File`, "error")
    // }
  }

  const renderContent = () => {
    return (
      <Box style={{ width: '100%' }}>
        <CustomAutocomplete
          autoHighlight
          sx={{ width: '100%' }}
          options={userList}
          id='autocomplete-autoHighlight'
          value={selectedAccount}
          onChange={(event, newValue) => setSelectedAccount(newValue)}
          // getOptionLabel={option => option.email || ''}
          getOptionLabel={(option) => `${option.email} - ${option.accountNumber}`}
          renderInput={params => <CustomTextField {...params} placeholder='Select Account' />}
        />
        {selectedAccount && <><Box style={{ width: '100%', display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop:"20px"}}>
          {fileBoxes.map((box, index) => (
            <div key={index}>
              <Box
                key={box.id}
                sx={{
                  width: {
                    xs: '90px',
                    sm: '100px',
                    md: '135px',
                    lg: '150px',
                  },
                  height: {
                    xs: '90px',
                    sm: '95px',
                    md: '115px',
                    lg: '130px',
                  },
                  borderWidth: 1,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '10px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  borderStyle: 'solid',
                  borderColor: 'primary.main',
                  cursor: 'pointer',
                  position: 'relative',
                  backgroundColor: (theme) =>
                    uploadedFiles[box.id] ? theme.palette.grey[200] : theme.palette.primary.contrastText,
                }}
                onClick={() => handleBoxClick(box.id)}
              >
                <input
                  type="file"
                  ref={(el) => (fileInputRefs.current[box.id] = el)}
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange(e, box.id)}
                  accept={box.accept}
                  multiple
                />
                <Avatar
                  variant="rounded"
                  sx={{
                    backgroundColor: 'action.selected',
                    width: {
                      xs: '28px',
                      sm: '32px',
                      md: '36px',
                    },
                    height: {
                      xs: '28px',
                      sm: '32px',
                      md: '36px',
                    },
                  }}
                >
                  <Icon icon={box.icon} style={{ height: '95%', width: '95%' }} />
                </Avatar>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: 'text.secondary',
                    textTransform: 'capitalize',
                    mt: 2,
                    fontSize: {
                      xs: '12px',
                      sm: '14px',
                      md: '16px',
                    },
                  }}
                >
                  {box.label}
                </Typography>
                <Box
                  sx={{
                    position: 'absolute',
                    display: 'flex',
                    top: 0,
                    right: 0,
                    width: {
                      xs: '16px',
                      sm: '20px',
                      md: '24px',
                    },
                    height: {
                      xs: '16px',
                      sm: '20px',
                      md: '24px',
                    },
                  }}
                >
                  {uploadedFiles[box.id] && uploadedFiles[box.id].length > 0 ? (
                    <Icon icon="icon-park-twotone:correct" />
                  ) : (
                    <Icon icon="line-md:upload-loop" />
                  )}
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    top: 0,
                    left: 0,
                    width: {
                      xs: '16px',
                      sm: '20px',
                      md: '24px',
                    },
                    height: {
                      xs: '16px',
                      sm: '20px',
                      md: '24px',
                    },
                  }}
                >
                  {uploadedFiles[box.id] && uploadedFiles[box.id].length > 0 ? (
                    <span className='uploadbadge'>{uploadedFiles[box.id].length}</span>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </div>
          ))}
        </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'end' }}>
            <Button variant="contained" sx={{ ml: '8px' }} onClick={submitFiles} disabled={isFileUploading}>
              {isFileUploading ? <Box sx={{ marginLeft: "5px", background: 'transparent', width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                <Icon icon="svg-spinners:6-dots-scale" width="16" height="16" color='black' />
              </Box> : "Upload Files"}
            </Button>
            <Button variant="tonal" sx={{ ml: '8px' }} onClick={resetUploadedFileData} disabled={isFileUploading}>
              {isFileUploading ? <Box sx={{ marginLeft: "5px", background: 'transparent', width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                <Icon icon="svg-spinners:6-dots-scale" width="16" height="16" color='black' />
              </Box> : "Reset"}
            </Button>
          </Box>
        </>
        }
        {renderError()}
      </Box>
    )
  }

  return renderContent()
}

export default Upload
